export const getGridDecorativeLabelStyle = (components, { palette = {} } = {}) => ({
  tilesGridCellDecorativeLabel: {
    color: palette.white,
    fontWeight: 600,
    fontSize: 12,
    lineHeight: '16px',

    '& .label-icon-and-text': {
      display: 'flex',
      borderRadius: 4,
      padding: [4, 8, 4, 6],
      marginRight: 6,
      // background: 'linear-gradient(158.29deg, #0078D4 16.69%, #4400D4 85.76%)',
      background: palette.neutralPrimary,
      '& .label-icon': {
        marginRight: 6,
      },
    },

    '& .label-secondary-text': {
      position: 'relative',
      left: -10,
      opacity: 0,
      transition: 'opacity 0.5s 0.1s, transform 0.3s 0.1s',
    },

    '& .additional-icon-content': {
      width: 25,
      height: 24,
      background: 'rgb(50,49,48, 0.6)',
      borderRadius: 4,
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      marginRight: 8,
      position: 'absolute',
      right: 50,
      '& .additional-icon': {
        width: 17,
      },
    },

    '& .label-additional-text': {
      position: 'absolute',
      right: 0,
      '& .label-additional-content': {
        background: palette.neutralPrimary,
        float: 'right',
        padding: 4,
        borderRadius: 4,
      },
    },
  },

  cellLabelDisplay: {
    display: 'flex',
    alignItems: 'center',
  },
});
